<section class="profile">

    <div class="profile-banner pb-3">
        <img src="../../assets/brand/profile_banner.png" class="img-fluid banner-opacity" alt="profile-banner">
        <div class="centered h1 text-gold">Playlist</div>
    </div>

    <div class="container my-5">
        <div class="row">
            <div class="col-12">
                <ng-container *ngIf="videoDetails">
                    <div
                        class="text-uppercase text-black font-oswald mb-3">
                        <h4 class="cat-title text-gold">{{videoDetails?.cat | uppercase}}</h4>
                        <div class="date-wrap text-muted">
                            {{videoDetails.created_at | date :'medium'}}
                        </div>
                    </div>
                </ng-container>
            </div>
            <div class="col-12 col-sm-8">
                <div class="video-modal main mb-3">
                    <div *ngIf="playlist && !noVideos" class="main-content">
                        <ng-container *ngIf="videoDetails">
                            <div class="modal-header text-center bg-black border-0 p-0">
                                <div class="col-3 text-white gold-border-right py-3" *ngFor="let item of videoDetails.rule_level"><span>{{item.rule_name | uppercase}}</span><br>
                                  <span class="text-gold">{{item.level_name | uppercase}}</span>
                                </div>
                            </div> 
                            <video oncontextmenu="return false;" controlsList="nodownload" #videoFileContainer [poster]="getThumbUrl(videoDetails.video_thumb)" id="player" playsinline controls>
                                <source src="{{getVideoUrl(videoDetails.video_url)}}" type="video/mp4">
                            </video>

                            <div class="main-body p-3">
                                <div class="d-flex flex-row">
                                    <div
                                        class="modal-title text-uppercase text-black d-flex justify-content-start font-oswald me-auto">
                                        {{videoDetails?.name | uppercase}}
                                        <span class="stars-wrap">
                                            <ng-container *ngFor="let item of [].constructor(5); let i = index">
                                                <span class="fa fa-star" [ngClass]="videoDetails?.difficulty_rating>=
                (i+1)? 'rating-class':null"></span>
                                            </ng-container>
                                        </span>
                                    </div>
                                </div>
                                <div class="info mx-1 my-2 bg-gold label-gold">{{videoDetails.cat | uppercase}}</div>
                                <span class="info mx-1 my-2 label-black"
                                    *ngFor="let skill of videoDetails.skills">{{skill.name |
                                    uppercase}}</span>

                                <p class="my-2" [innerHTML]="videoDetails.description"></p>
                                <ul class="nav nav-pills bg-black mt-3 rounded-3 font-oswald" id="pills-tab" role="tablist">

                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link active" id="pills-instructor-tab" data-bs-toggle="pill"
                                            data-bs-target="#pills-instructor" type="button" role="tab"
                                            aria-controls="pills-instructor" aria-selected="false">INSTRUCTOR TAKING
                                            POINTS</button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link" id="pills-options-tab" data-bs-toggle="pill"
                                            data-bs-target="#pills-options" type="button" role="tab"
                                            aria-controls="pills-options" aria-selected="true">Definitions</button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link" id="pills-errors-tab" data-bs-toggle="pill"
                                            data-bs-target="#pills-errors" type="button" role="tab"
                                            aria-controls="pills-errors" aria-selected="false">COMMON ERRORS</button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link" id="pills-leagal-tab" data-bs-toggle="pill"
                                            data-bs-target="#pills-leagal" type="button" role="tab"
                                            aria-controls="pills-leagal" aria-selected="false">LEGALITY TIPS</button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link" id="pills-notes-tab" data-bs-toggle="pill"
                                            data-bs-target="#pills-notes" type="button" role="tab"
                                            aria-controls="pills-notes" aria-selected="false">OTHER NOTES</button>
                                    </li>
                                </ul>
                                <div class="tab-content bullets-change p-3" id="pills-tabContent">
                                    <div class="tab-pane fade" id="pills-options" role="tabpanel"
                                        aria-labelledby="pills-options-tab" tabindex="0">
                                        <table>
                                            <tr *ngFor="let option of videoDetails.videos_options">
                                                <th>{{option.option_name}}</th>
                                                <td>{{option.choice_name}}</td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div class="tab-pane fade show active" id="pills-instructor" role="tabpanel"
                                        aria-labelledby="pills-instructor-tab" tabindex="1">
                                        <ul>
                                            <li *ngFor="let skill of videoDetails.instructions">{{skill.text}}</li>
                                        </ul>
                                    </div>

                                    <div class="tab-pane fade" id="pills-errors" role="tabpanel"
                                        aria-labelledby="pills-errors-tab" tabindex="2">
                                        <ul>
                                            <li *ngFor="let skill of videoDetails.commonerrors">{{skill.text}}</li>
                                        </ul>
                                    </div>
                                    <div class="tab-pane fade" id="pills-leagal" role="tabpanel"
                                        aria-labelledby="pills-leagal-tab" tabindex="3">
                                        <ul>
                                            <li *ngFor="let skill of videoDetails.legalitytips">{{skill.text}}</li>
                                        </ul>
                                    </div>
                                    <div class="tab-pane fade" id="pills-notes" role="tabpanel"
                                        aria-labelledby="pills-notes-tab" tabindex="4">
                                        <ul>
                                            <li *ngFor="let skill of videoDetails.notes">{{skill.text}}</li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>

            </div>
            <div class="col-12 col-sm-4">
                <div class="playlist-sidebar pb-2">
                    <div class="top-title px-3 py-2">
                        <div>
                            PLAYLIST
                        </div>
                        <div class="text-muted">
                            {{playlist?.length}} videos
                        </div>
                        <hr class="text-gold mb-0">
                    </div>
                    <ul>
                        <li *ngFor="let video of playlist, let i=index">
                            <div *ngIf="video" class="playlist-item" [ngClass]="index == i ? 'active' : ''" (click)="openDetails(video)">  
                                <img src={{getThumbUrl(video.video_thumb)}}/> 
                                <div class="video-description">
                                  <p class="heading mb-0">{{video?.name | uppercase}} </p>
                                  <small class="text-gold">{{video?.cat | uppercase}}</small>
                                </div>
                            </div>  
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        

    </div>

</section>